/**
 * Korean copy catalog for the `community` feature (forums, threads, Hall of
 * Legends). Keys mirror the `t('community.*')` calls in
 * packages/@gamecodex/world-ui/src/features/community.
 */
export const communityKo = {
  // CommunityPage
  'community.page.seoTitle': '커뮤니티',
  'community.page.seoDescription':
    'Grymwyrd 커뮤니티에 참여하세요: 포럼, 세계관 이론, GM 도구, 홈브류, Hall of Legends.',
  'community.page.eyebrow': '어둠의 집결',
  'community.page.title': '커뮤니티',
  'community.page.intro':
    '전술을 나누고 이론을 풀어내며 홈브류를 공유하고 공식 설정에 가까워지세요. 당신이 남기는 모든 글은 영원한 황혼 속에서 코인과 명성을 얻습니다.',
  'community.page.loading': '신자들을 모으는 중…',
  'community.page.forumCategories': '포럼 카테고리',
  'community.page.categoryStats': '{threads}개 스레드 · {posts}개 게시물',
  'community.page.recentActivity': '최근 활동',
  'community.page.liveFeed': '실시간 피드',
  'community.page.recentEmpty':
    '포럼이 조용하네요. 죽은 자들을 깨우려면 먼저 토론을 시작하세요.',
  'community.page.hallOfLegends': 'Hall of Legends',
  'community.page.hallBlurb': '위대한 기여자들과 그들이 공식 설정에 새긴 캐릭터들.',
  'community.page.enterTheHall': 'Hall 입장하기',
  'community.page.playerSpotlights': '플레이어 주목',
  'community.page.summoningLegends': '전설을 소환하는 중…',
  'community.page.sampleNotice': '라이브 포럼이 깨어나는 동안 커뮤니티 샘플 콘텐츠를 보여주고 있습니다.',

  // FlagButton
  'community.flag.errorQueued':
    '지금은 중재자에게 연락할 수 없지만, 신고가 대기열에 등록되었습니다.',
  'community.flag.ariaLabel': '이 게시물을 중재팀에 신고',
  'community.flag.label': '신고',
  'community.flag.modalTitle': 'Keepers에 신고',
  'community.flag.successDelivered':
    '신고가 중재자에게 전달되었습니다. Keepers가 감사합니다.',
  'community.flag.close': '닫기',
  'community.flag.signInNotice':
    '문제를 설명할 수 있지만, 중재자에게 신고가 전달되려면 로그인해야 합니다.',
  'community.flag.whyFlagging': '이 게시물을 신고하는 이유는?',
  'community.flag.reason.spamOrAdvertising': '스팸 또는 광고',
  'community.flag.reason.harassmentOrAbuse': '괴롭힘 또는 학대',
  'community.flag.reason.spoilersWithoutWarning': '경고 없는 스포일러',
  'community.flag.reason.offTopic': '주제 벗어남',
  'community.flag.reason.otherDescribeBelow': '기타 (아래에 설명)',
  'community.flag.describeIssue': '문제 설명하기',
  'community.flag.detailPlaceholder': 'Keepers에게 무엇이 잘못되었는지 알려주세요…',
  'community.flag.cancel': '취소',
  'community.flag.reporting': '신고 중…',
  'community.flag.submitReport': '신고 제출',

  // ForumCategoryPage
  'community.category.seoTitle': '{name} — 포럼',
  'community.category.seoDescription': 'Grymwyrd의 {name} 포럼에서의 토론.',
  'community.category.breadcrumb': '커뮤니티',
  'community.category.entityTiedPrefix': '엔티티 연결 게시판 · 스레드는 다음과 연결될 수 있습니다',
  'community.category.encyclopediaEntries': '백과사전 항목',
  'community.category.sampleNotice': '라이브 포럼이 깨어나는 동안 샘플 스레드를 보여주고 있습니다.',

  // HallOfLegendsPage
  'community.legends.seoTitle': 'Hall of Legends',
  'community.legends.seoDescription':
    'Grymwyrd에 대한 위대한 기여자들과 그들이 공식 설정에 새긴 캐릭터들.',
  'community.legends.breadcrumb': '커뮤니티',
  'community.legends.title': 'Hall of Legends',
  'community.legends.intro':
    '여기 서 있는 것은 영원한 황혼의 건축가들입니다 — 그들의 말이 법이 되었고, 그들의 캐릭터는 너무도 사랑받아 공식 설정에 새겨진 기여자들입니다.',
  'community.legends.loading': '초를 켜는 중…',
  'community.legends.topContributors': '상위 기여자',
  'community.legends.noContributors':
    '아직 전설이 나타나지 않았습니다. 글을 남기고 이론을 펼쳐 당신의 자리를 차지하세요.',
  'community.legends.canonizedCharacters': '공식화된 캐릭터',
  'community.legends.noCharacters':
    '아직 공식화된 캐릭터가 없습니다. 괴수도감은 다음 공포를 기다리고 있습니다.',
  'community.legends.sampleNotice': '라이브 Hall이 봉헌되는 동안 샘플 전설을 보여주고 있습니다.',

  // NestedReplies
  'community.replies.replyBy': '{author}의 답변',
  'community.replies.reply': '답변',
  'community.replies.replyToPlaceholder': '{author}에게 답변하기…',
  'community.replies.unlike': '이 게시물 좋아요 취소',
  'community.replies.like': '이 게시물 좋아요',

  // PlayerSpotlight
  'community.spotlight.rep': '{rep} 명성',
  'community.spotlight.viewInEncyclopedia': '백과사전에서 {name} 보기',

  // PostComposer
  'community.composer.placeholder': '어둠에 당신의 목소리를 더하세요…',
  'community.composer.signInPrompt': '로그인하여 토론에 참여하고 당신의 말에 코인을 벌어보세요.',
  'community.composer.signInToReply': '로그인하여 답변하기',
  'community.composer.youFallback': '당신',
  'community.composer.saveError':
    '당신의 답변이 서버에 아직 저장되지 않았습니다 — 로컬에서만 표시됩니다.',
  'community.composer.writeReply': '답변 쓰기',
  'community.composer.writePost': '게시물 쓰기',
  'community.composer.replyText': '답변 텍스트',
  'community.composer.postText': '게시물 텍스트',
  'community.composer.posting': '게시 중…',
  'community.composer.postReply': '답변 게시',
  'community.composer.post': '게시',
  'community.composer.cancel': '취소',
  'community.composer.coinsPerPost': '게시물당 +{count} 코인',
  'community.composer.coinsEarned': '당신의 게시물에 대해 +{count} 코인을 얻었습니다!',

  // ThreadItem
  'community.thread.pinned': '고정된 스레드',
  'community.thread.byPrefix': '작성자',
  'community.thread.repliesTitle': '{count}개의 답변',
  'community.thread.likesTitle': '{count}개의 좋아요',
  'community.thread.viewsTitle': '{count}회 조회',
  'community.thread.entityEntry': '{type} 항목',

  // ThreadList
  'community.threadList.empty':
    '아직 토론이 시작되지 않았습니다. 침묵을 깨는 첫 번째 사람이 되세요.',

  // ThreadPage
  'community.threadPage.loading': '스레드를 여는 중…',
  'community.threadPage.seoDescription': 'Grymwyrd 커뮤니티 포럼의 토론.',
  'community.threadPage.replyCount': '{count}개의 답변',
  'community.threadPage.opened': '{time}에 시작됨',
  'community.threadPage.entityEntry': '{type} 항목',
  'community.threadPage.sampleNotice': '라이브 포럼이 깨어나는 동안 샘플 토론을 보여주고 있습니다.',
  'community.threadPage.openingPostBy': '{author}의 초기 게시물',
  'community.threadPage.repliesHeading': '답변',
  'community.threadPage.noReplies': '아직 답변이 없습니다. 부름에 응한 첫 번째 사람이 되세요.',
  'community.threadPage.addYourReply': '당신의 답변 추가하기',
}
